export default {
    values: {
        escalation : 'escalonamento',
        'must have initial contribution between 0 and 1': 'deve ter contribuição inicial entre 0 e 1',
        'Initial Contribution': 'Contribuição Inicial'
    }
}
